/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type AvailabilityEnum = (typeof AvailabilityEnum)[keyof typeof AvailabilityEnum];

export const AvailabilityEnum = {
  UNAVAILABLE: 'UNAVAILABLE',
  UNLICENSED: 'UNLICENSED',
  NO_BENEFITS: 'NO_BENEFITS',
  CREDIT_BENEFIT: 'CREDIT_BENEFIT',
  DISCOUNT_BENEFIT: 'DISCOUNT_BENEFIT',
  FULL_BENEFITS: 'FULL_BENEFITS',
} as const;
